import { groupBy } from '@popety_io/popety-io-lib'
import { createSelector } from '@reduxjs/toolkit'
import { SliceState } from './types'

const estimateSelector = (state: SliceState) => state?.estimateSummary

const informationsSelector = (state: SliceState) =>
  state?.estimateSummary?.informations

const estimateLoadingSelector = (state: SliceState) =>
  state?.estimateSummary?.loading

const estimateErrorSelector = (state: SliceState) =>
  state?.estimateSummary?.error

const estimateLandSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.land

const poisSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.environment?.pois || []

const poiCategoriesSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.environment?.poiCategories

const groupedPoisSelector = createSelector(poisSelector, (pois) => {
  return Object?.values(groupBy('category', pois))
})

const companySelector = (state: SliceState) => state?.estimateSummary?.company

const userSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.user

const availableSectionsSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.available_sections

const availableUntilSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.available_until

const estimateBuildingSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.building

const creationDateSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.creation_date

const energySelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.energy

const environmentSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.environment

const themeSelector = (state: SliceState) => state?.estimateSummary?.theme

const marketSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.market

const noiseSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.noise

const propertySelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.property

const officeSelector = (state: SliceState) => state?.estimateSummary?.office

const estimationSelector = (state: SliceState) =>
  state?.estimateSummary?.informations?.estimation

// const estimateSelectedDwellingsSelector = createSelector(
//   estimateSelector,
//   (estimate) => {
//     return estimate?.dwellingSelected
//   },
// )

// const estimateListingStatsSelector = createSelector(
//   estimateSelector,
//   (estimate) => {
//     return estimate?.mutateAggsPurchase || []
//   },
// )

// const annoncementSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.annoncement || []
// })

// const buySelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.buy || []
// })

// const themeSelector = (state) => state?.estimateSummary?.theme

// const comparablesIdsSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.comparablesIds
// })

// const transactionsIdsSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.transactionsIds
// })

// const comparablesSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.comparables || []
// })

// const transactionsSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.transactions || []
// })

// const faosSelector = createSelector(estimateSelector, (estimate) => {
//   return estimate?.faos || []
// })

// const officeSelector = (state) => state?.estimateSummary?.office

// const estimateDefaultValue = (state) => state?.estimateSummary?.defaultValue

export {
  estimateSelector,
  estimateLandSelector,
  poisSelector,
  poiCategoriesSelector,
  groupedPoisSelector,
  estimateLoadingSelector,
  estimateErrorSelector,
  companySelector,
  // estimateSelectedDwellingsSelector,
  userSelector,
  availableSectionsSelector,
  availableUntilSelector,
  estimateBuildingSelector,
  creationDateSelector,
  energySelector,
  environmentSelector,
  marketSelector,
  noiseSelector,
  propertySelector,
  informationsSelector,
  // estimateListingStatsSelector,
  // annoncementSelector,
  // buySelector,
  themeSelector,
  officeSelector,
  estimationSelector,
  // comparablesSelector,
  // transactionsSelector,
  // faosSelector,
  // comparablesIdsSelector,
  // transactionsIdsSelector,
  // officeSelector,
  // estimateDefaultValue,
}
